import en from './en.json'
import it from './it.json'

export const usersTranslations = {
	en,
	it
} as const
